// @flow

import React, { type Config } from 'react';
import {
  ListContainer,
  Header,
  MinimalHeader,
  ListWrapper,
  ListItem as ListItemComponent,
  CollapseButton,
} from './components';
import withLimit from './withLimit';
import withScheme, { type SchemeProps } from '../withScheme';
import type {
  Props as OwnProps,
  StateProps,
} from './types';
import { SCHEME_DEFAULT } from './constants';

type ListProps = OwnProps & {|
  buttonText?: {
    expanded: string,
    collapsed: string,
  },
  ...StateProps,
|};

type Props = {
  ...ListProps,
  ...SchemeProps,
};

const List = ({
  colorScheme = SCHEME_DEFAULT,
  scheme,
  border = 'none',
  className = '',
  collapsed = false,
  collapsible = false,
  buttonText = {
    expanded: '',
    collapsed: '',
  },
  compact = false,
  items,
  visibleItemCount,
  listStyle,
  minimalistic = false,
  onCollapse,
  title,
  subtitle,
}: Props) => (
  <ListContainer
    className={className}
    border={border}
    scheme={scheme}
    schemeName={colorScheme || SCHEME_DEFAULT}
    minimalistic={minimalistic}
  >
    {!minimalistic && (
      <Header
        scheme={scheme}
        title={title}
        subtitle={subtitle}
      />
    )}
    {minimalistic && (
      <MinimalHeader
        scheme={scheme}
        title={title}
        subtitle={subtitle}
        onCollapse={onCollapse}
        collapsed={collapsed || false}
        collapsible={collapsible}
        buttonText={buttonText} // @todo: Moet naar ACF
        nbItems={items.length}
        limits={visibleItemCount}
        minimalistic={minimalistic}
      />
    )}
    <ListWrapper>
      {items.map(({ usp, url, icon }, index) => (
        <ListItemComponent
          index={index}
          url={url}
          type={listStyle === 'icons' ? icon : listStyle}
          key={index} // eslint-disable-line react/no-array-index-key
          limit={minimalistic ? 0 : visibleItemCount}
          collapsed={collapsed}
          compact={compact}
          minimalistic={minimalistic}
          scheme={scheme}
        >
          {usp}
        </ListItemComponent>
      ))}
    </ListWrapper>
    {!minimalistic && collapsible && visibleItemCount
      && <CollapseButton
        scheme={scheme}
        onClick={onCollapse}
        collapsed={collapsed}
        collapsible={collapsible}
        limits={visibleItemCount}
        nbItems={items.length}
        buttonText={buttonText}
      />}

  </ListContainer>
);

List.defaultProps = {
  buttonText: {
    expanded: '',
    collapsed: '',
  },
  colorScheme: 'default',
  border: 'none',
  className: '',
  collapsed: false,
  collapsible: false,
  compact: false,
  minimalistic: false,
};

export default withLimit(withScheme<Config<Props, SchemeProps>>(List));
